/* Výpočet z eMonsteru: serverový čas, kalendář skladu, bez falešného slibu při výpadku. */
(()=>{
 if(window.emonsterExpedice)return;window.emonsterExpedice=true;
 const cache=new Map(),bezi=new Set();let naplanovano=false;
 const datum=d=>{const v=new Date(d+'T12:00:00Z');return ['v neděli','v pondělí','v úterý','ve středu','ve čtvrtek','v pátek','v sobotu'][v.getUTCDay()]+' '+v.getUTCDate()+'. '+(v.getUTCMonth()+1)+'.';};
 function zobraz(el,v){
  const sekce=el.closest('.shopify-section')||document;
  const vstup=sekce.querySelector('form[action*="/cart/add"] [name="id"]');
  const id=vstup?.value||el.dataset.varianta;
  const nafuk=el.dataset.obchod==='bambuleparty'?sekce.querySelector('[name="mpd_inflation_type"]:checked')?.value:null;
  const nedostupne=el.dataset.obchod==='bambuleparty'&&sekce.querySelector('#mpd-btn-cart')?.disabled;
  const vhodne=el.dataset.skladem.split(',').includes(String(id))&&(!nafuk||nafuk==='none')&&!nedostupne;
  const t=el.querySelector('.emonster-expedice-text');
  if(!vhodne||!v||v.do<=performance.now()){el.hidden=true;return;}
  const j=v.data,odeslani=j.expedice===j.dnes?'Objednejte do '+j.cutoff+' a odešleme dnes':'Odešleme '+datum(j.expedice);
  const doruceni=j.doruceniOd===j.doruceniDo?datum(j.doruceniDo):datum(j.doruceniOd)+' – '+datum(j.doruceniDo);
  const text=odeslani+' — předpokládané doručení '+doruceni;
  if(t.textContent!==text)t.textContent=text;
  el.hidden=false;
 }
 async function obnov(obchod){
  if(bezi.has(obchod))return;bezi.add(obchod);const start=performance.now();
  try{
   const r=await fetch('https://emonster.alltoys.cz/api/verejna-expedice/'+encodeURIComponent(obchod),{credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(6000)});
   if(!r.ok)throw Error('Termín nedostupný');const j=await r.json();
   if(![j.dnes,j.expedice,j.doruceniOd,j.doruceniDo].every(x=>/^\d{4}-\d{2}-\d{2}$/.test(x))||!/^\d{2}:\d{2}$/.test(j.cutoff)||!Number.isFinite(j.validForMs))throw Error('Neplatný termín');
   cache.set(obchod,{data:j,do:start+Math.max(0,Math.min(30000,j.validForMs)),zkus:performance.now()+1500});
  }catch{cache.set(obchod,{do:0,zkus:performance.now()+15000});}
  finally{bezi.delete(obchod);vykresli();}
 }
 function vykresli(){
  document.querySelectorAll('.emonster-expedice').forEach(el=>{
   const id=el.dataset.obchod,v=cache.get(id);zobraz(el,v);
   if((!v||v.do<=performance.now())&&(!v||v.zkus<=performance.now()))obnov(id);
  });
 }
 function plan(){if(naplanovano)return;naplanovano=true;setTimeout(()=>{naplanovano=false;vykresli();},0);}
 // Témata při změně varianty mění formulář nebo nahradí produktovou sekci.
 document.addEventListener('change',plan);document.addEventListener('visibilitychange',()=>{if(!document.hidden){cache.clear();plan();}});
 new MutationObserver(plan).observe(document.documentElement,{childList:true,subtree:true});
 setInterval(()=>{if(!document.hidden)vykresli();},500);
 vykresli();
})();
